import { apiUrl } from "../config";

/**
 * Translates a given string using your backend Google Translate proxy.
 * @param {string} text - Text to translate
 * @param {string} targetLang - Language code (e.g., "es", "vi")
 * @returns {Promise<string>}
 */
export async function translateText(text, targetLang = "es") {
  try {
    const res = await fetch(apiUrl("/api/translate-quote"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text, target: targetLang })
    });

    const data = await res.json();
    return data.translated || text;
  } catch (error) {
    console.error("Translation failed:", error);
    return text; // fallback to original text if API fails
  }
}